<template>
  <div class="note">
    <v-modal
      name="note"
      :shiftY="device.isMobile ? 0.1 : 0.5"
      :width="device.isMobile ? '90%' : '60%'"
      :height="device.isMobile ? '80%' : '50%'"
      :minWidth="300"
      :minHeight="300"
      :resizable="!device.isMobile"
      :draggable="!device.isMobile"
      :clickToClose="false"
    >
      <div class="note-header">
        <div>
          <span class="title">議事録</span>
          <span v-if="sendable" class="sendable blink">送信可能...</span>
        </div>
        <div v-if="sendable" class="sendable-buttons">
          <mdb-btn color="light" @click.native="onClickCancel">
            キャンセル
          </mdb-btn>
          <mdb-btn color="primary" @click.native="$emit('onClickSendNoteText', innerNoteText)">
            送信
          </mdb-btn>
        </div>
        <div v-else class="mr-2 clickable">
          <mdb-icon icon="times" size="lg" @click.native="$emit('onClickCloseNoteModal')" />
        </div>
      </div>
      <div class="note-content">
        <textarea
          ref="noteTextarea"
          v-model="innerNoteText"
          class="note-textarea"
          spellcheck="false"
          :disabled="!initialized"
        />
      </div>
    </v-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NoteModal',
  props: {
    modal: Boolean,
    initialized: Boolean,
    device: Object
  },
  data() {
    return {
      innerNoteText: ''
    }
  },
  computed: {
    sendable: function() {
      return this.innerNoteText != this.noteText
    },
    ...mapGetters({
      noteText: 'note/text'
    })
  },
  methods: {
    onClickCancel: function() {
      this.innerNoteText = this.noteText
    }
  },
  watch: {
    modal: function(value) {
      if (value) {
        this.$modal.show('note')
      } else {
        this.$modal.hide('note')
      }
    },
    noteText: function(value) {
      this.innerNoteText = value
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/_variables";
@import "@/styles/_mediaquery";

.note-content {
  padding: 10px;
  cursor: move;
  width: 100%;
  height: calc(100% - 60px);
}

.note-textarea {
  color: black;
  background: transparent;
  border: none;
  resize: none;
  width: 100%;
  height: 100%;
}

.note-header {
  color: black;
  cursor: move;
  width: 100%;
  min-height: 60px;
  padding: 10px;
  background: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  .title {
    font-weight: 600;
    user-select: none;
  }

  .sendable {
    font-size: 12px;
    font-weight: 600;
    user-select: none;
    display: block;
  }

  .sendable-buttons {
    button {
      margin: 10px 0 10px 10px;
      font-size: 12px;
      padding: 5px 10px;

      @include mq(lg) {
        font-size: inherit;
        padding: 0.25rem 1.5rem;
      }
    }
  }
}

.blink {
  animation: blink 0.5s ease-in-out infinite alternate;
}

@keyframes blink {
  0% {
    opacity:0;
  }
  100% {
    opacity:1;
  }
}
</style>
